
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ContactForm extends Vue {
    private name = '';
    private email = '';
    private message = '';

    private submitting = false;
    private submitted = false;
    private error: string | null = null;
    private success: string | null = null;

    private async submit(event: Event) {
        this.submitted = false;
        this.error = null;
        this.success = null;
        this.submitting = true;

        const theForm = event.target as null | HTMLFormElement;

        if (theForm !== null) {
            const formData = new FormData(theForm);

            this.submitting = true;
            fetch(theForm.action, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                /** @ts-ignore */
                body: new URLSearchParams(formData).toString(),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Oops, something went wrong! Please try again later or email me.');
                    }

                    this.submitted = true;
                    this.success = 'Thank you, I\'ll be in touch!';
                    theForm.reset();
                    setTimeout(() => (this.submitted = false), 10000);
                })
                .catch((error) => this.error = error.message)
                .finally(() => (this.submitting = false));
        }
    }

    private onFormInput(event: Event) {
        this.$emit('input', event);

        this.error = null;
        this.success = null;
        this.submitted = false;
    }
}
